export default __webpack_public_path__ + "static/media/right-arrow.d19ce8f8.svg";